import { DevTools } from 'features/dev-tools'
import { DevPasscodeModal } from 'features/dev-tools/ui/DevPasscodeModal'
import { useMemo } from 'react'
import { createHashRouter, Navigate, RouterProvider } from 'react-router'
import { useAuthStore } from 'shared/store/auth'
import { hasAdminPermission } from 'shared/lib/permissions/permissions'
import { AppLayout } from './ui/layout/AppLayout'
import { Providers } from './ui/providers/Providers'
import { AuthGate } from './ui/AuthGate'
import { GET_ROUTES, GET_ROUTES_WITH_PERMISSIONS } from './ui/routes'
import { Dev } from 'pages/dev'

// Route paths fed to the dev panel's navigator (param'd ones act as templates).
const DEV_ROUTE_PATHS = GET_ROUTES().map((route) => route.path)

function AppRouter() {
	const user = useAuthStore((s) => s.user)
	const router = useMemo(() => {
		const routes = GET_ROUTES_WITH_PERMISSIONS({ user })
		const home = hasAdminPermission(user) ? '/admin' : '/'
		return createHashRouter([
			// Ungated dev tools — no AuthGate ancestor, reachable without signing in.
			{ path: '/dev', element: <Dev /> },
			// Everything else stays behind the auth gate.
			{
				element: (
					<AuthGate>
						<AppLayout />
					</AuthGate>
				),
				children: routes,
			},
			{ path: '*', element: <Navigate to={home} replace /> },
		])
	}, [user])

	return <RouterProvider router={router} />
}

export function App() {
	return (
		<Providers>
			<AppRouter />
			<DevTools routePaths={DEV_ROUTE_PATHS} />
			<DevPasscodeModal />
		</Providers>
	)
}

export default App
